import { memo } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/Modal';

const BzModalHeader = ({ closeButton, className, ...props }) => {
    return (
        <Modal.Header closeButton={closeButton} {...props} className={className}>
            {props.children}
        </Modal.Header>
    )
}
BzModalHeader.propTypes = {
    closeButton: PropTypes.bool

}
BzModalHeader.defaultProps = {
    closeButton: false
}

export default memo(BzModalHeader)